import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import { useCompetitionExerciseTypeApi } from '../../../hooks/useCompetitionExerciseTypeApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { CompetitionExerciseTypeDTO } from '../../../services/apiClient';
import CompetitionExerciseTypeForm from '../../../components/forms/CompetitionExerciseTypeForm';

const CompetitionExerciseTypeCreate: React.FC = () => {
  const { create, isLoading } = useCompetitionExerciseTypeApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Competition Exercise Types', href: '/admin/competitionexercisetypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: CompetitionExerciseTypeDTO) => {
    try {
      await create(data);
      navigate('/admin/competitionexercisetypes');
    } catch (error) {
      console.error('Error creating CompetitionExerciseType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/competitionexercisetypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.CompetitionExerciseType.Edit"
    >
        <CompetitionExerciseTypeForm
          initialValues={{} as CompetitionExerciseTypeDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/competitionexercisetypes')}
        />
    </AdminLayout>
  );
};

export default CompetitionExerciseTypeCreate;
